module.exports = function(amount) {
  if (this.items[this.activeQuantityEdit].quantity === amount) {
    return ' checked="checked"';
  }
  return '';
};